import { styled } from "@mui/material"
import { textAlign } from "@mui/system"

export const Head = styled('header')(({ theme }) => ({ props }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 0 0 96px',
    background: '#ebf1fb',
    [theme.breakpoints.down('lg')]: {
        padding: '0  0 0 48px'
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse',
        alignItems: 'start',
        padding: '0  0 0 0'
    }
}))

export const ImgSection = styled('div')(({ theme }) => (props) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
        width: '100vw'
    }
}))

export const Img = styled('img')(({ theme }) => (props) => ({
    width: '648px',
    [theme.breakpoints.down('md')]: {
        width: '35vw'
    },
    [theme.breakpoints.down('sm')]: {
        width: '100vw'
    }
}))

export const TextSection = styled('div')(({ theme }) => (props) => ({
    minHeight: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    margin: ' 24px 80px 24px 0 ',
    width: '90%',
    justifyContent: 'start',
    marginBottom: '32px',
    "& > h2 ": {
        color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary : theme.palette.text.darkSecondary,
        fontSize: theme.typography.HeadingHero.fontSize,
        fontWeight: theme.typography.HeadingHero.fontWeight,
        lineHeight: theme.typography.HeadingHero.lineHeight,
        letterSpacing: theme.typography.HeadingHero.letterSpacing,
        wordSpacing: '1px',
        margin: '0 5px',
        [theme.breakpoints.down('md')]: {
            fontSize: '26px',
            lineHeight: '30px',
        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '24px',
            lineHeight: '30px',
        }
    },
    [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        textAlign: 'left',
        margin: ' 24px 16px',
    },
    "& > p ": {
        fontSize: '1.5vw',
        fontWeight: '400',
        lineHeight: '2.3vw',
        letterSpacing: '0em',
        textAlign: 'justify',
        margin: "5px",
        color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark,
        [theme.breakpoints.down('md')]: {
            fontSize: '18px',
            lineHeight: '22.5px',
            textAlign: 'start',

        },
        [theme.breakpoints.down('sm')]: {
            fontSize: '16px',
            width: '90%',
            lineHeight: '19.5px',
        },
        [theme.breakpoints.down('xs')]: {
            fontSize: '16px',
            width: '90%',
            lineHeight: '19.5px',
        }

    }
}

))

export const TextHeading = styled('h1')(({ theme }) => (props) => ({
    fontSize: theme.typography.HeadingHero.fontSize,
    fontWeight: theme.typography.HeadingHero.fontWeight,
    lineHeight: theme.typography.HeadingHero.lineHeight,
    letterSpacing: theme.typography.HeadingHero.letterSpacing,
    color: theme.palette.mode === 'light' ? theme.palette.text.lightSecondary
        : theme.palette.text.darkSecondary,
    wordSpacing: '1px',
    margin: '0',
    [theme.breakpoints.down('md')]: {
        fontSize: '26px',
        lineHeight: '30px',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '24px',
        lineHeight: '30px',
    }
}))

export const TextHeadingBlue = styled('p')(({ theme }) => (props) => ({
    fontSize: theme.typography.HeadingHero.fontSize,
    fontWeight: theme.typography.HeadingHero.fontWeight,
    lineHeight: theme.typography.HeadingHero.lineHeight,
    letterSpacing: theme.typography.HeadingHero.letterSpacing,
    color: "#73DBF4",
    display: 'inline-flex',
    wordSpacing: '1.5px',
    margin: '0px 4px',
    [theme.breakpoints.down('md')]: {
        fontSize: '26px',
        lineHeight: '30px',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '24px',
    }

}))

export const TextDescription = styled('p')(({ theme }) => (props) => ({
    fontSize: '1.5vw',
    fontWeight: '400',
    lineHeight: '2.3vw',
    letterSpacing: '0em',
    color: theme.palette.mode === 'light' ? theme.palette.text.light : theme.palette.text.dark,
    [theme.breakpoints.down('md')]: {
        fontSize: '18px',
        lineHeight: '22.5px',
    },
    [theme.breakpoints.down('sm')]: {
        fontSize: '16px',
        width: '50%',
        lineHeight: '19.5px',
    },
    [theme.breakpoints.down('xs')]: {
        fontSize: '16px',
        width: '80%',
        lineHeight: '19.5px',
    }
}))
export const ButtonSection = styled('div')(({ theme }) => (props) => ({
    width: '120px',
    marginTop: '20px',
    alignItems: 'right',
    [theme.breakpoints.down('lg')]: {
        fontSize: '2.5vw',
        lineHeight: '3vw',
        width: '15vw',
    },
    [theme.breakpoints.down('md')]: {
        fontSize: '2.5vw',
        lineHeigh: '3vw',
        width: '12vw',
        paddingLeft: '5px'

    },
    [theme.breakpoints.down('sm')]: {
        lineHeight: '3.7vw',
        width: '20vw',
        alignItems: 'right',
        paddingLeft: '5px'
    },
    [theme.breakpoints.down('xs')]: {
        lineHeight: '3.7vw',
        width: '142px',
        alignItems: 'right',
    },

}))
export const ButtonSectionDownload = styled('div')(({ theme }) => (props) => ({
    width: '90%',
    height: '80px',
    display: 'flex',
    flexDirection:"column",
    alignItems: 'flex-end',
    // justifyContent: 'right',
    backgroundColor: '#fff',
    gap: '16px',
    [theme.breakpoints.down('sm')]: {
        display: 'none'
    },
}))
export const ImgDownload = styled('img')(({ theme }) => (props) => ({
    height: '60px',
}))
